import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const BusinessFinishing = () => {
  return (
    <SubLayout
      title="도장·습식·방수·석공사"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_cad.jpg"
    >
      <Intro>
        주식회사 두성시스템은 도장·습식·방수·석공사업 면허를 바탕으로,
        <strong> 습식 및 방수공사를 주력분야</strong>로 수행합니다.
        철저한 자재 선별과 시공 관리를 통해 건축물의 내구성과 마감 품질을 높입니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">💧</div>
          <h4>방수공사</h4>
          <p>옥상·지하·화장실 등 누수 취약 부위에 대한 전문 방수 시공을 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧱</div>
          <h4>습식공사(미장·조적)</h4>
          <p>미장, 조적 등 습식 마감 공사로 견고하고 균일한 벽체를 완성합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🎨</div>
          <h4>도장공사</h4>
          <p>내·외부 도장 및 특수 도장으로 미관과 보호 성능을 동시에 구현합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🪨</div>
          <h4>석공사</h4>
          <p>내·외장 석재 시공으로 고급스럽고 내구성 높은 마감을 제공합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>방수 하자 제로 시공</h4>
        <p>주력분야인 방수공사에서 부위별 최적 공법을 적용해 누수 하자를 원천 차단합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>습식 마감 전문성</h4>
        <p>미장·조적 등 습식공사의 숙련 기술로 균열 없는 견고한 마감을 실현합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>검증된 자재 사용</h4>
        <p>품질이 검증된 자재만을 선별 사용하여 시공 후 내구성과 신뢰도를 보장합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessFinishing;
